import React, { ReactNode } from 'react';
import { Grid, GridItem } from '@televet/kibble-ui/build/chakra';
import { Text, TextSize } from '@televet/kibble-ui/build/components/Text';

interface IGridItemContentProps {
  gridName: string;
  gridItemContent: string | ReactNode;
  textSize: TextSize;
}

interface IAutomationGridProps {
  automationGridContent: IGridContentProps;
  textSize: TextSize;
  background: string;
}

export interface IGridContentProps {
  name: string;
  sendingHours: string | ReactNode;
  event: string;
  clientOrPet: string;
  active: string | ReactNode;
}

type IGridContentType = keyof IGridContentProps;

const GridItemContent = ({ gridName, gridItemContent, textSize }: IGridItemContentProps): JSX.Element => {
  return (
    <GridItem area={gridName}>
      <Text size={textSize}>{gridItemContent}</Text>
    </GridItem>
  );
};

const AutomationGrid = ({ automationGridContent, textSize, background }: IAutomationGridProps): JSX.Element => {
  const gridName: IGridContentType[] = ['name', 'sendingHours', 'event', 'clientOrPet', 'active'];
  return (
    <Grid
      templateAreas={`"name sendingHours event clientOrPet active"`}
      gridTemplateColumns="30% 20% 30% 10% 10%"
      h={10}
      gap={4}
      background={background}
      alignItems="center"
      mb={1}
    >
      {gridName.map((gridNameValue, index) => {
        return (
          <GridItemContent
            key={`${gridNameValue}-${index}`}
            gridName={gridNameValue}
            gridItemContent={automationGridContent[gridNameValue]}
            textSize={textSize}
          />
        );
      })}
    </Grid>
  );
};

export default AutomationGrid;
